const routes = [
    {
        path: "/pcgc",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "pdrmapplication_index"
        }
    },
    {
        path: "/pcgc/my-applications",
        component: () => import("../pages/student/Index"),
        meta: {
            isAuthenticated: true,
            permission: "pdrmapplication_studentindex"
        }
    },
    {
        path: "/pcgc/application-form",
        component: () => import("../pages/student/ApplicationForm"),
        meta: {
            isAuthenticated: true,
            permission: "pdrmapplication_store"
        }
    }
];

export default routes;
